import { DateTime } from "luxon";

const formatDateString = (dateString, timezoneName) => {
  try {
    // Parse the ISO date string and create a DateTime object
    const utcDateTime = DateTime.fromISO(dateString, { zone: "utc" });

    if (!utcDateTime.isValid) {
      console.error("Invalid date string:", dateString);
      return "Invalid Date";
    }

    // Convert to the specified timezone - Luxon automatically handles DST
    const adjustedDateTime = utcDateTime.setZone(timezoneName);

    if (!adjustedDateTime.isValid) {
      console.error("Invalid timezone:", timezoneName);
      return "Invalid Date";
    }

    console.log(
      "Converted date string",
      dateString,
      "to",
      adjustedDateTime.toFormat("LLLL d, yyyy"),
      "in timezone",
      timezoneName,
      "Is in DST:",
      adjustedDateTime.isInDST
    );

    // Format as "Month Day, Year" (e.g., "January 15, 2025")
    return adjustedDateTime.toFormat("LLLL d, yyyy");
  } catch (error) {
    console.error("Error in formatDateString:", error);
    return "Invalid Date";
  }
};

export default formatDateString;
